import React from 'react'
import { RequestNextApi } from '../../../api/Request';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';

function useMembershipCategories() {
    const [membershipCategories, setMembershipCategories] = React.useState(null);
    const [loading, setLoading] = React.useState(false)
    const fetchMembershipCategories = async () => {
        try {
            setLoading(true)
            const result = await RequestNextApi.post('/global-variables',
                {}
            );
            if (result.data.success) {
                setMembershipCategories(result.data.globals.membershipCategories);
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (error) {
            ShowNotification.error('Failed fetching membership types');
        } finally {
            setLoading(false)
        }
    };

    React.useEffect(() => {
        fetchMembershipCategories();
    }, []);

    return {
        membershipCategories,
        loading
    }
}

export default useMembershipCategories